var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row mt-4 container-table"},[_c('div',{staticClass:"col-md-12"})])])
}]

export { render, staticRenderFns }